import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OrderSummaryCard = ({ items, deliveryFee, onRemoveItem, onUpdateQuantity, onCheckout }) => {
  const subtotal = items?.reduce((sum, item) => sum + (item?.price * item?.quantity), 0);
  const total = subtotal + deliveryFee;

  return (
    <div className="bg-card rounded-xl shadow-lg p-4 md:p-6 lg:p-8 sticky top-20">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="ShoppingCart" size={20} color="var(--color-primary)" />
        </div>
        <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">Order Summary</h2>
      </div>
      {items?.length === 0 ? (
        <div className="text-center py-8 md:py-12">
          <Icon name="ShoppingBag" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
          <p className="text-muted-foreground text-sm md:text-base">Your cart is empty</p>
          <p className="text-muted-foreground text-xs md:text-sm mt-2">Add items from the menu to get started</p>
        </div>
      ) : (
        <>
          <div className="space-y-3 md:space-y-4 mb-4 md:mb-6 max-h-64 md:max-h-80 overflow-y-auto">
            {items?.map((item) => (
              <div key={item?.id} className="flex gap-3 md:gap-4 p-3 md:p-4 bg-muted/50 rounded-lg">
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground text-sm md:text-base line-clamp-1">{item?.name}</h3>
                  <p className="text-xs md:text-sm text-muted-foreground mt-1">SSP {item?.price?.toLocaleString()}</p>
                  {item?.customization && (
                    <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{item?.customization}</p>
                  )}
                </div>
                <div className="flex flex-col items-end gap-2">
                  <button
                    onClick={() => onRemoveItem(item?.id)}
                    className="text-destructive hover:text-destructive/80 transition-colors"
                    aria-label="Remove item"
                  >
                    <Icon name="Trash2" size={16} />
                  </button>
                  <div className="flex items-center gap-2 bg-background rounded-lg p-1">
                    <button
                      onClick={() => onUpdateQuantity(item?.id, Math.max(1, item?.quantity - 1))}
                      className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center hover:bg-muted rounded transition-colors"
                      aria-label="Decrease quantity"
                    >
                      <Icon name="Minus" size={14} />
                    </button>
                    <span className="text-sm md:text-base font-semibold w-6 md:w-8 text-center">{item?.quantity}</span>
                    <button
                      onClick={() => onUpdateQuantity(item?.id, item?.quantity + 1)}
                      className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center hover:bg-muted rounded transition-colors"
                      aria-label="Increase quantity"
                    >
                      <Icon name="Plus" size={14} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="border-t border-border pt-4 md:pt-6 space-y-2 md:space-y-3">
            <div className="flex justify-between text-sm md:text-base">
              <span className="text-muted-foreground">Subtotal</span>
              <span className="font-semibold text-foreground">SSP {subtotal?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between text-sm md:text-base">
              <span className="text-muted-foreground">Delivery Fee</span>
              <span className="font-semibold text-foreground">SSP {deliveryFee?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between text-base md:text-lg lg:text-xl pt-2 md:pt-3 border-t border-border">
              <span className="font-bold text-foreground">Total</span>
              <span className="font-bold text-primary">SSP {total?.toLocaleString()}</span>
            </div>
          </div>

          <Button
            variant="default"
            size="lg"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={onCheckout}
            className="mt-4 md:mt-6 bg-accent hover:bg-accent/90"
          >
            Order via WhatsApp
          </Button>
        </>
      )}
    </div>
  );
};

export default OrderSummaryCard;